<div class="d-flex align-items-center justify-content-center min-vh-100" style="background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%); min-height: 100vh; padding: 20px;">
  <div class="card text-center shadow-lg border-0" style="max-width: 540px; width: 100%; border-radius: 20px; background: rgba(30, 41, 59, 0.9); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.1); color: white; padding: 2rem;">
    <div class="card-body">
      <div class="mb-4">
        <span style="font-size: 56px;">🚀</span>
      </div>
      <h2 class="font-weight-bold text-white mb-2" style="font-size: 26px;">Deploy com Sucesso!</h2>
      <p class="text-info font-weight-bold mb-4" style="font-size: 16px;">Ambiente de Stage Atualizado</p>
      
      <div class="p-3 mb-4 rounded text-left" style="background: rgba(15, 23, 42, 0.6); border: 1px solid rgba(255, 255, 255, 0.05); font-size: 14px;">
        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Versão Publicada:</span>
          <span class="badge badge-success px-2 py-1" style="font-size: 13px;">{{ versao }}</span>
        </div>
        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Ambiente:</span>
          <span class="font-weight-bold text-light">{{ ambiente }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span class="text-muted">Data do Deploy:</span>
          <span class="font-weight-bold text-light">{{ dataDeploy }}</span>
        </div>
      </div>

      <div class="alert alert-success d-flex align-items-center justify-content-center py-2 px-3 mb-4" style="border-radius: 10px; background: rgba(34, 197, 94, 0.15); border: 1px solid rgba(34, 197, 94, 0.3); color: #4ade80;">
        <i class="fa fa-check-circle mr-2"></i>
        <span>Pipeline Azure DevOps executada com sucesso.</span>
      </div>

      <a href="/login" class="btn btn-info btn-round px-4 py-2 font-weight-bold shadow-sm" style="background: #0ea5e9; border: none;">
        <i class="fa fa-arrow-right mr-1"></i> Ir para o Login
      </a>
    </div>
  </div>
</div>
